/* eslint-disable @typescript-eslint/naming-convention */
import {AbstractControl} from '@angular/forms';

export function ValidateTeamId(control: AbstractControl) {
  if (!isNaN(control.value) && control.value) {
    return { validTeamId: true };
  }
  return false;
}
